module.exports = __webpack_public_path__ + "img/5.23ef78a7.png";